var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qimingxing"},[_c('PublicCert',{attrs:{"logo":_vm.Logo3,"type":'qmx',"color":'#36b9bf'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }